import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unmappedColumns: {
		id: 'project-create-importer-upload-flow.mapping-screen.unmapped-columns-banner.unmapped-columns',
		defaultMessage: 'Columns waiting to be mapped.',
		description:
			'Message for banner letting the user know they have columns that do not have a field mapped to them',
	},
	goToNext: {
		id: 'project-create-importer-upload-flow.mapping-screen.unmapped-columns-banner.go-to-next',
		defaultMessage: 'Highlight unmapped column',
		description: 'Button text to go to next column without a field mapped to it',
	},
	allFieldsMapped: {
		id: 'project-create-importer-upload-flow.mapping-screen.unmapped-columns-banner.all-fields-mapped',
		defaultMessage: 'All fields are mapped, nice work!',
		description: 'Message for banner letting the user know they have mapped all columns',
	},
});
